import React from 'react';

import { Link } from 'gatsby';

import * as style from './MobileDropdown.module.css';

const MobileDropdown = ({ item, onClick }) => {
  return (
    <div className={style.mainBox}>
      {item.subMenu.map((i, index) => {
        return (
          <Link
            to={i.path}
            key={index}
            className={style.dropLink}
            activeClassName="active"
            onClick={onClick}
          >
            {i.title}
          </Link>
        );
      })}{' '}
    </div>
  );
};

export default MobileDropdown;
